/**
 * Shared-tag chip colors — same scheme as the TAGS block on ICR / EEI / etc.
 *
 * Shared tags (requirement_entity_tags) do not persist a color. Corpus tags do
 * (ColorGenerator on create). For shared tags we reuse {@link getTagColor} /
 * {@link tagChipStyles} so every surface matches {@link TagBadge} / {@link TagChip}.
 */
import {getTagColor, tagChipStyles} from '../../../components/documentContent/tagColors';

/** Returns {bg, fg, outline} matching TagBadge / TagChip styling for a tag name. */
export function tagColor(tag) {
    const name = String(tag ?? '').trim();
    const hex = getTagColor({name});
    const styles = tagChipStyles(hex, true);
    return {
        bg: styles.bgcolor,
        fg: styles.color,
        outline: styles.outline,
        /** @deprecated use outline — kept for callers that still set border */
        border: hex,
    };
}
